import React, { useState, useEffect } from "react";
import "./thankyou.css";
import axios from "axios";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { updategameover, getScore } from "../../scoreservice";

function Thankyou({ updateHeader }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, SetriddlerusLogo] = useState("/img/thankyou-min.gif");
  const storedUserData = JSON.parse(sessionStorage.getItem('userData'));

  const EY_ORG_ID = "c5e6cf74-05c5-4871-9706-172ea49b2fae";
const EY_THANKYOU_URL = "https://games.extramileplay.com/EY-Thankyou/thankyou.php";

  // Total admin points (from default_cat / cat_items / points) – mirrors PHP logic
  const [totalAdminPoints, setTotalAdminPoints] = useState(0);

  const S3_URL = process.env.REACT_APP_FETCH_S3_UPLOADS || "";
  const S3_BUCKET_URL = (process.env.REACT_APP_S3BUCKET_URL || "").replace(/\/?$/, "/");
  const resolveUrl = (path) => {
    if (!path) return "";
    const normalized = path.startsWith("uploads") ? path : path;
    return `${S3_URL}${normalized}`;
  };
  const getDvSourceImageUrl = (imgPath) => {
    if (!imgPath) return "";
    const filename = imgPath.includes("/") ? imgPath.split("/").pop() : imgPath;
    if (filename.length < 25) return resolveUrl(imgPath);
    return `${S3_BUCKET_URL}${filename}`;
  };

  console.log("themeData----",themeData);

  console.log("totalAdminPoints----",totalAdminPoints);



  const [textcolor, Setcolorcode] = useState(null);
  const [score, setScore] = useState(0);
  const [time, setTime] = useState(null);
  // const [time, setTime] = useState(0);
  const [fetchError, setFetchError] = useState(false);
  const [playedTime, setPlayedTime] = useState("00:00");
  const handleSuccess = (msg) => {
    return Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: msg,
      confirmButtonText: 'OK',
      customClass: { popup: 'custom-success-popup' }
    });
  };

  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
 

  const handleError = (msg) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: msg,
      customClass: { popup: 'custom-success-popup' }
    });
  };

  useEffect(() => {

    updateHeader({
      backButtonRedirect: "/game"
    });

    const fetchData = async () => {
      const storedSession = sessionStorage.getItem("userData");
      console.log(storedSession);
      const storedTheme = sessionStorage.getItem("themeData");

      if (storedSession && storedTheme) {
        const parsedUser = JSON.parse(storedSession);
        const parsedTheme = JSON.parse(storedTheme);

        setUserData(parsedUser);
        setThemeData(parsedTheme);
        Setcolorcode(parsedTheme.landing_page_title_color);
     
      } else {
        navigate("/login"); // Redirect if session data is missing
      }
    };

    fetchData();
  }, [navigate]);

  // Compute totalAdminPoints from themeData (default_cat, cat_items, points) – PHP logic
  useEffect(() => {
    if (!themeData) return;

    const defaultCat = Array.isArray(themeData.default_cat)
      ? themeData.default_cat
      : themeData.default_cat
      ? Object.values(themeData.default_cat)
      : [];
    const catItems = themeData.cat_items || {};

    const filteredItems = {};
    defaultCat.forEach((cat) => {
      if (catItems[cat]) filteredItems[cat] = catItems[cat];
    });

    const allImages = [];
    Object.keys(filteredItems).forEach((binKey, binIndex) => {
      const binNumber = binIndex + 1;
      const images = filteredItems[binKey];
      const arr = Array.isArray(images) ? images : [images];
      arr.forEach((img) => {
        const path = typeof img === "string" ? img : img?.url || img?.path || "";
        allImages.push({
          url: getDvSourceImageUrl(path.startsWith("uploads") ? path : `uploads/${path}`),
          bin: binNumber,
        });
      });
    });

    const number_of_items = allImages.length;
    const dynamic_rightPoints = parseInt(themeData.points, 10) || 0;
    const totalAdminpoints = number_of_items * dynamic_rightPoints;

    setTotalAdminPoints(totalAdminpoints);
    sessionStorage.setItem("totalAdminpoints", String(totalAdminpoints));
  }, [themeData]);

  useEffect(() => {

    if (!storedUserData?.sessionId) return;

    const fetchScore = async () => {

      const payload = {
        userId: storedUserData.userId || storedUserData.userid,
        sessionId: storedUserData.sessionId,
        organizationId: storedUserData.organizationId
      };

      const res = await getScore(payload);

      console.log("Full API response:", res);

      if (res.status === "success") {

        setScore(res.data.total_score);   // ✅ total_score
        setTime(res.data.time);           // ✅ raw time
        setPlayedTime(res.data.time);     // ✅ directly use DB time
      
      }

    };

    fetchScore();

  }, []);



  useEffect(() => {

    if (!storedUserData?.sessionId) return;
    if (!playedTime) return;
    if (playedTime === "00:00") return;

    const sendReportUpdate = async () => {

      try {

        const role1 =
          storedUserData?.roles ||
          storedUserData?.user_type ||
          storedUserData?.role;

        const isGuest = role1 === "GUEST_USER";

        const ReportId =
          storedUserData?.reportId ||
          storedUserData?.report_id;

        let reportUrl;
        let reportRequestData;

        if (isGuest) {

          reportUrl =
            process.env.REACT_APP_UPDATE_GUEST_REPORT_URL;

          reportRequestData = {
            reportId: ReportId,
            points: Number(score),
            time: playedTime 
          };

        } else {

          reportUrl =
            `${process.env.REACT_APP_UPDATE_REPORT_URL}${ReportId}`;

            console.log("REACT_APP_UPDATE_REPORT_URL", process.env.REACT_APP_UPDATE_REPORT_URL);
            console.log("ReportId", ReportId);
            console.log("score", score);
            console.log("playedTime", playedTime);  

          reportRequestData = {
            reportId: ReportId,
            points: Number(score),
            time: playedTime // ✅ USING PLAYED TIME
          };

        }

        const headers = {
          "client-secret": process.env.REACT_APP_CLIENT_SECRET,
          "Content-Type": "application/json",
          "Idempotency-Key": uuidv4()
        };

        if (!isGuest) {
          headers["Authorization"] =
            `Bearer ${storedUserData.token}`;
        }

        console.log("Report URL:", reportUrl);
        console.log("Report Request:", reportRequestData);

        await axios.put(reportUrl, reportRequestData, { headers });

        console.log("Report updated successfully");

      } catch (error) {
        console.error("Report update failed:", error);
      }
    };

    // existing gameover API
    const reportData = {
      sessionId: storedUserData.sessionId,
      organizationId: storedUserData.organizationId,
      userId: storedUserData.userId || storedUserData.userid,
      gameover: true,
      time_played: playedTime
    };

    updategameover(reportData);

    // ✅ call report update API
    sendReportUpdate();

  }, [playedTime, score]);


  



  useEffect(() => {

    if (!themeData) return;

    const body = document.body;

    const updateBackground = () => {

      if (!body.classList.contains("common-bg")) return;

      const isMobile = window.innerWidth <= 768;
      const isPortrait = window.matchMedia("(orientation: portrait)").matches;

      if (isMobile && isPortrait) {
        body.style.backgroundImage = `url(${themeData.background_mob})`;
      } else {
        body.style.backgroundImage = `url(${themeData.background_desk})`;
      }
    };

    updateBackground(); // initial
    window.addEventListener("resize", updateBackground);

    return () => {
      window.removeEventListener("resize", updateBackground);
    };

  }, [themeData]);

  // Same message as displayed: "You have scored X in Y minutes."
  const printScore = `You have scored ${score} out of ${totalAdminPoints} in ${playedTime || "00:00"} minutes.`;

  // Redirect to Zydus external thank you page when organization matches
  // useEffect(() => {
  //   const orgId = storedUserData?.organizationId;
  
  //   if (time == null && score === 0) return;

  //   const params = new URLSearchParams({
  //     gameName: "Bin Toss",
  //     message: printScore,
  //     sessionId: storedUserData.sessionId || ""
  //   });
   

  // }, [storedUserData, score, playedTime, time, printScore]);

  useEffect(() => {
    const orgId = storedUserData?.organizationId;
    if (!orgId || String(orgId).toLowerCase() !== EY_ORG_ID.toLowerCase()) return;
    // Wait until score has been fetched (time is set from getScore response)
    if (time == null && score === 0) return;
    const params = new URLSearchParams({
      gameName: "Bin Toss",
      message: printScore,
      sessionId: storedUserData.sessionId || ""
    });
    const url = `${EY_THANKYOU_URL}?${params.toString()}`;
    window.location.href = url;
  }, [storedUserData, score, playedTime, time, printScore]);




  return (
    <>
      {/* Mobile portrait overlay advising rotation */}
      {/* <div className="rotate-overlay">
        <div className="rotate-message">
          Please rotate your device for best experience
        </div>
      </div> */}
      <div className="thankyou-main-container" style={{ textAlign: "center" }}>
        {/* <div className="thankyou-main-container1" style={{ textAlign: "center" }}>
          <img src={riddlerusLogo} className="login-logo" />
        </div> */}
        <div>
          <div className="main_text_ty" style={{ color: textcolor }}>
            <strong>{themeData?.custom_text_thank_you_page}</strong>
            <br />
          </div>

          <p className="score" style={{ margin: "10px 0", color: textcolor }}>
            You have scored <strong>{score}</strong>
            {totalAdminPoints > 0 && (
              <> out of <strong>{totalAdminPoints}</strong></>
            )}
            {" "}in <strong>{playedTime}</strong> minutes.
          </p>

          {/* thankyou_toggle: show thankyou_content from themeData */}
          {(themeData?.thankyou_toggle === true || themeData?.thankyou_toggle === "true") &&
            Array.isArray(themeData?.thankyou_content) &&
            themeData.thankyou_content.length > 0 && (
              <div className="thankyou-content-row" style={{ marginTop: "10px" }}>
                {themeData.thankyou_content.map((value, i) => {
                  if (i === 0) {
                    return (
                      <div key={i} className="thankyou-content-col-12">
                        <h1
                          className="thankyou-content-title text-center mb-4"
                          style={{ color: themeData?.ty_Textcolor || themeData?.landing_page_title_color || textcolor }}
                        >
                          {value}
                        </h1>
                      </div>
                    );
                  }
                  const parts = String(value).split(":", 2);
                  const title = parts[0] || "";
                  const text = parts[1] !== undefined ? parts[1].trim() : "";
                  const offsetClass = i === 1 ? " thankyou-content-offset" : "";
                  return (
                    <div
                      key={i}
                      className={`thankyou-content-card-wrap${offsetClass}`}
                    >
                      <div className="thankyou-content-card card-box card shadow-sm text-center d-flex flex-column justify-content-center align-items-center">
                        <h5 className="thankyou-content-card-title" style={{ fontWeight: 600, color: themeData?.ty_Textcolor }}>
                          {title}
                        </h5>
                        <p className="thankyou-content-card-text" style={{ fontSize: "14px", marginTop: "10px" }}>
                          {text}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
        
        </div>


      </div>

    </>

  );
}
export default Thankyou;